const stringToByteArray = (string, byteLength = 16) => {
  const byteArray = new Uint8Array(byteLength);
  for (let x = 0; x < byteArray.length; x++) {
    byteArray[x] = parseInt(string.substr(x * 2, 2), byteLength);
  }
  return byteArray;
};

export default stringToByteArray;
